export default __webpack_public_path__ + "static/media/slot13.81ea3dfa.png";